<template>
  <div class="clients">
    <h2 class="clients__heading text-center mb-60">Brands we have worked with</h2>
    <div class="slider" v-if="logosFirst && logosFirst.length">
      <div class="slider__track" :style="`width: calc(15rem * ${logoCount})`">
        <div v-for="client in logosFirst" :key="client._id" class="slide">
          <a v-if="client?.href"
             :href="client?.href"
             class="slide__link">
            <img :src="client.image.image.asset.url"
                 :alt="client.image.alt || client.title"
                 height="auto"
                 width="auto" />
          </a>
          <img v-else
               :src="client.image.image.asset.url"
               :alt="client.image.alt || client.title"
               height="auto"
               width="auto" />
        </div>
      </div>
      <div class="slider__track" :style="`width: calc(15rem * ${logoCount})`">
        <div v-for="client in logosFirst" :key="client._id" class="slide">
          <a v-if="client?.href"
             :href="client?.href"
             class="slide__link">
            <img :src="client.image.image.asset.url"
                 :alt="client.image.alt || client.title"
                 height="auto"
                 width="auto" />
          </a>
          <img v-else
               :src="client.image.image.asset.url"
               :alt="client.image.alt || client.title"
               height="auto"
               width="auto" />
        </div>
      </div>
    </div>
    <div class="slider" v-if="logosSecond && logosSecond.length">
      <div class="slider__track slider__track--two" :style="`width: calc(15rem * ${logoSecondRowCount})`">
        <div v-for="client in logosSecond" :key="client._id" class="slide">
          <a v-if="client?.href"
             :href="client?.href"
             class="slide__link">
            <img :src="client.image.image.asset.url"
                 :alt="client.image.alt || client.title"
                 height="auto"
                 width="auto" />
          </a>
          <img v-else
               :src="client.image.image.asset.url"
               :alt="client.image.alt || client.title"
               height="auto"
               width="auto" />
        </div>
      </div>
      <div class="slider__track slider__track--two" :style="`width: calc(15rem * ${logoSecondRowCount})`">
        <div v-for="client in logosSecond" :key="client._id" class="slide">
          <a v-if="client?.href"
             :href="client?.href"
             class="slide__link">
            <img :src="client.image.image.asset.url"
                 :alt="client.image.alt || client.title"
                 height="auto"
                 width="auto" />
          </a>
          <img v-else
               :src="client.image.image.asset.url"
               :alt="client.image.alt || client.title"
               height="auto"
               width="auto" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from '../../../sanity.js';
const query = `*[_type == "clients"]{
  ...,
  _id,
  title,
  clients[]->{
    _id,
    title,
    image{
      alt,
      image{
        asset->{
          url
        }
      }
    },
    href
  },
  logosFirstRow[]->{
    _id,
    title,
    href,
    image{
      alt,
      image{
        asset->{
          url
        }
      }
    }
  },
  logosSecondRow[]->{
    _id,
    title,
    href,
    image{
      alt,
      image{
        asset->{
          url
        }
      }
    }
  }
}`;
export default {
  name: "LogoCarousel",
  data() {
    return {
      content: [],
      loading: false,
      error: null,
      breakpoints: {
        0: {
          itemsToShow: 2,
          snapAlign: "left",
        },
        576: {
          itemsToShow: 3,
          snapAlign: "left",
        },
        768: {
          itemsToShow: 4,
          snapAlign: "left",
        },
        992: {
          itemsToShow: 5,
          snapAlign: "left",
        },
      },
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    things() {
      return this.content[0] || [];
    },
    logosFirst() {
      return this.content[0]?.logosFirstRow || [];
    },
    logosSecond() {
      return this.content[0]?.logosSecondRow || [];
    },
    logoCount() {
      return this.content[0].logosFirstRow?.length || 0;
    },
    logoSecondRowCount() {
      return this.content[0].logosSecondRow?.length || 0;
    },
    clientsHeading() {
      return this.content[0]?.title || 'Our Clients';
    }
  },
  methods: {
    fetchData() {
      this.error = this.home = null;
      this.loading = true;
      sanity.fetch(query).then(
          (content) => {
            this.loading = false;
            this.content = content;
          },
          (error) => {
            this.error = error;
          }
      );
    },
  }
};
</script>


<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.clients {
  padding: 5rem 0;
  width: 100%;
  @media (min-width: 500px) {
    padding: 10rem 0;
  }
  .clients__heading {
    display: block;
    font-size: 2.5rem;
    font-weight: bold;
    margin: 0 auto 2rem auto;
    position: relative;
    text-align: center;
    @media (min-width: 500px) {
      font-size: 3rem;
      margin: 0 auto 4rem auto;
      padding: 0 2rem;
    }
  }
  .slider {
    display: flex;
    height: 7rem;
    margin: 1rem auto;
    overflow: hidden;
    position: relative;
    cursor: default;
    user-select: none;
    touch-action: none;
    width: 100vw;
  }
  .slider .slider__track {
    animation: scroll-l 90s linear infinite;
    display: flex;
  }
  .slider .slider__track--two {
    animation: scroll-l 90s linear infinite;
    margin-left: 6rem;
  }
  .slider .slide {
    height: 7rem;
    width: 15rem;
    display: flex;
    justify-content: center;
    text-align: center;
    img {
      filter: grayscale(100);
      padding: 0 2.5rem;
      vertical-align: middle;
      margin: 0 auto;
      display: inline-block;
      max-height: 5rem;
      max-width: 100%;
      object-fit: contain;
      transition: 0.3s;

      &:hover {
        filter: grayscale(0);
        transition: 0.3s;
      }
    }
  }
  .slider .slide .slide__link {
    display: inline-block;
    overflow: visible;
    &:hover {
      background-color: transparent;
      cursor: pointer;
    }
  }

  @keyframes scroll-l {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  @keyframes scroll-r {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100%);
    }
  }
}
</style>

